import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import { ICoordinatesEvent, IHsl, IRgb } from './color-picker.type';
import { getCheckboard } from './utils';
@Component({
  selector: 'bixi-color-alpha',
  exportAs: 'bixiColorAlpha',
  host: {
    '[class.bixi-color-alpha]': 'true'
  },
  template: `
    <div class="bixi-color-alpha-checkboard" [ngStyle]="checkboardStyles">
    </div>
    <div class="bixi-color-alpha-gradient" [ngStyle]="gradientStyles"></div>
    <div bixi-coordinates (coordinatesChange)="onCoordinatesChange($event)" class="bixi-color-alpha-slider">
      <div class="bixi-color-alpha-pointer" [style.left.%]="pointerLeft">
        <div class="bixi-color-circle"></div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiColorAlphaComponent implements OnChanges {
  gradientStyles!: { [key: string]: string };
  checkboardStyles = {
    background: `url(${getCheckboard('transparent', 'rgba(0,0,0,.08)', 8)}) center left`
  };
  pointerLeft!: number;
  @Input() hsl!: Required<IHsl>;
  @Input() rgb!: Required<IRgb>;
  @Output() colorChange = new EventEmitter<IHsl>();

  ngOnChanges() {
    this.gradientStyles = {
      background: `linear-gradient(to right, rgba(${this.rgb.r},${this.rgb.g
        },${this.rgb.b}, 0) 0%,
        rgba(${this.rgb.r},${this.rgb.g},${this.rgb.b}, 1) 100%)`
    };
    // TODO: not good, but work well
    let percent = this.rgb.a * 100;
    percent = percent > 97 ? 97 : percent;
    percent = percent < 3 ? 3 : percent;
    this.pointerLeft = percent;
  }

  onCoordinatesChange(event: ICoordinatesEvent): void {
    const { left, width } = event;
    let a: number;
    if (left < 0) {
      a = 0;
    } else if (left > width) {
      a = 1;
    } else {
      a = Math.round(left * 100 / width) / 100;
    }

    if (this.hsl.a !== a) {
      const color: IHsl = {
        h: this.hsl.h,
        s: this.hsl.s,
        l: this.hsl.l,
        a
      };
      this.colorChange.emit(color);
    }
  }
}
